import React from 'react'
import { Col } from 'react-bootstrap'

const IconField = ({
    children,
    style = {},
}) => {
    return (
        <Col xs={12} sm={6} style={{ ...style, paddingTop: '10px' }}>
            {children}
        </Col>
    )
}

export default IconField